import React, { useState } from 'react';
import TimeAgo from 'react-timeago';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import FlagIcon from '@mui/icons-material/Flag';

const Comment = ({ comment, level = 0, kilroyCookie, onReply, handleThumbnailClick }) => {
  const [isLiking, setIsLiking] = useState(false);
  const [showReplyInput, setShowReplyInput] = useState(false);
  const [replyText, setReplyText] = useState('');
  const [likes, setLikes] = useState(comment.likes || []);
  
  const commentId = comment._id || comment.id;
  const indentStyle = { marginLeft: `${level * 20}px` };
  const isLiked = likes.some(like => like.cookie === kilroyCookie);
  
  const handleLike = async () => {
    if (isLiking) return;
    setIsLiking(true);
    
    try {
      let fd = new FormData();
      fd.append('like[comment_id]', commentId);
      fd.append('like[cookie]', kilroyCookie);
      
      const response = await fetch('/likes', {
        method: 'POST',
        body: fd
      });
      
      const result = await response.json();
      
      if (result.action === 'liked') {
        // Add the new like
        setLikes(prev => [...prev, result.like]);
      } else if (result.action === 'unliked') {
        // Remove the like
        setLikes(prev => prev.filter(like => like.cookie !== kilroyCookie));
      }
    } catch (error) {
      console.error('Error toggling comment like:', error);
    } finally {
      setIsLiking(false);
    }
  };
  
  const handleFlag = async () => {
    const reason = prompt('Why are you flagging this comment?');
    if (!reason) return;
    
    try {
      let fd = new FormData();
      fd.append('flag[comment_id]', commentId);
      fd.append('flag[cookie]', kilroyCookie);
      fd.append('flag[reason]', reason);
      
      await fetch('/flags', {
        method: 'POST',
        body: fd
      });
      
      alert('Comment flagged successfully');
    } catch (error) {
      console.error('Error flagging comment:', error);
      alert('Error flagging comment');
    }
  };
  
  const submitReply = async () => {
    if (!replyText.trim()) return;
    
    try {
      let fd = new FormData();
      fd.append('comment[body]', replyText);
      fd.append('comment[cookie]', kilroyCookie);
      fd.append('comment[post_id]', comment.post_id);
      fd.append('comment[reply_to_comment_id]', commentId);
      
      const response = await fetch('/comments', {
        method: 'POST',
        body: fd
      });
      
      const result = await response.json();
      if (result.comment && onReply) {
        onReply(result.comment);
        setReplyText('');
        setShowReplyInput(false);
      }
    } catch (error) {
      console.error('Error posting reply:', error);
    }
  };
  
  return (
    <div>
      <div style={{
        ...indentStyle, 
        marginTop: '8px', 
        textAlign: 'left', 
        backgroundColor: level > 0 ? 'rgba(255,255,255,0.05)' : 'transparent', 
        padding: '8px', 
        borderRadius: '5px',
        borderLeft: level > 0 ? '2px solid #444' : 'none'
      }}>
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          <img 
            alt='' 
            onClick={() => handleThumbnailClick && handleThumbnailClick(comment.tid)} 
            style={{ width: '34px', height: '34px', marginRight: '8px', borderRadius: '17px', cursor: 'pointer' }} 
            src={comment.thumbnail} 
          />
          
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '14px', color: '#ffffff', marginBottom: '4px' }}>
              {comment.body}
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', fontSize: '12px', color: '#cccccc' }}>
              <TimeAgo date={comment.created_at} />
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }} onClick={handleLike}>
                {isLiked ? <FavoriteRoundedIcon style={{ fontSize: '16px', color: '#ff4444' }} /> : <FavoriteBorderRoundedIcon style={{ fontSize: '16px' }} />}
                <span>{likes.length}</span>
              </div>
              
              <button 
                onClick={() => setShowReplyInput(!showReplyInput)}
                style={{ background: 'none', border: '1px solid #666', color: '#ccc', padding: '2px 8px', borderRadius: '3px', cursor: 'pointer', fontSize: '12px' }}
              >
                Reply
              </button>
              
              <FlagIcon 
                style={{ fontSize: '16px', cursor: 'pointer', color: '#666' }} 
                onClick={handleFlag}
                title="Flag comment"
              />
            </div>
          </div>
        </div>
        
        {showReplyInput && (
          <div style={{ marginTop: '10px', marginLeft: '42px' }}>
            <form onSubmit={(e) => { e.preventDefault(); submitReply(); }}>
              <input 
                type='text' 
                placeholder="Write a reply..."
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                style={{ 
                  width: '70%', 
                  marginRight: '10px', 
                  padding: '5px', 
                  borderRadius: '3px', 
                  border: '1px solid #666', 
                  background: '#333', 
                  color: '#fff' 
                }}
              />
              <button type="submit" style={{ marginRight: '5px', padding: '5px 10px' }}>Send</button>
              <button type="button" onClick={() => { setShowReplyInput(false); setReplyText(''); }}>Cancel</button>
            </form>
          </div>
        )}
      </div>
      
      {comment.replies && comment.replies.map(reply => (
        <Comment 
          key={reply._id || reply.id}
          comment={reply} 
          level={level + 1} 
          kilroyCookie={kilroyCookie}
          onReply={onReply}
          handleThumbnailClick={handleThumbnailClick}
        />
      ))}
    </div>
  );
};

export default Comment;
